import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { Subscription, filter, iif, map, of, switchMap } from 'rxjs';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { AnimationOptions } from 'ngx-lottie';

import { AppInitService } from './core/services/app-init.service';
import { AppInitStatus } from './core/enums/app-init-status';
import { AutoUnsub } from './core/decorators/auto-unsub.decorator';
import { LoggingService } from './core/services/logging.service';
import { ManifestService } from './core/services/manifest.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('inOutLoader', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [style({ opacity: 0 }), animate('.3s')]),
      transition(':leave', [animate('.5s', style({ opacity: 0 }))]),
    ]),
    trigger('inOutContent', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('.5s .3s', style({ opacity: 1 })),
      ]),
    ]),
  ],
})
@AutoUnsub()
export class AppComponent implements OnInit {
  private _defaultLanguage: string = 'fr';
  private _observers: Subscription = new Subscription();
  public title = 'dashboard-nmosd';
  public now = new Date();
  public layout = '';
  public appInitStatus = AppInitStatus;
  public initStatus: AppInitStatus = AppInitStatus.LOAD;
  public spinnerOptions: AnimationOptions = {
    path: 'assets/animations/dashboard-spinner.json',
    loop: true,
    autoplay: true,
  };
  public options: AnimationOptions = {
    path: 'assets/animations/dashboard-login.json',
    loop: false,
    autoplay: true,
  };
  version: string = '';
  isFullTimeActivity = 'female';
  min = 1;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private renderer2: Renderer2,
    private appInitService: AppInitService,
    private manifestService: ManifestService,
    private loggingService: LoggingService
  ) {}

  ngOnInit(): void {
    this.setObservers();

    this.manifestService.getManifestData().subscribe((data) => {
      this.version = data.LongVersion;
    });
  }

  setObservers(): void {
    this._observers.add(this.routerObserver());
  }

  routerObserver(): Subscription {
    return this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        switchMap((response) => {
          if (
            this.activatedRoute.firstChild.snapshot.routeConfig.path === '404'
          ) {
            this.appInitService.changeAppInitStatus(AppInitStatus.DONE);
          }
          return iif(
            () => this.initStatus == AppInitStatus.LOAD,
            this.appInitService.status.pipe(map((res) => [response, res])),
            of([response, null])
          );
        })
      )
      .subscribe((response: any[]) => {
        this.layout = '';
        let activatedRoute = this.activatedRoute.firstChild;
        while (activatedRoute) {
          const data: any = activatedRoute.snapshot.data;

          this.layout = data['layout'] ?? '';

          if (!data['hasHeader']) {
            this.renderer2.removeStyle(document.body, 'padding-top');
          }

          activatedRoute = activatedRoute.firstChild;
        }

        if (response[1] !== null) {
          this.initStatus = response[1];
        }
      });
  }
}
